import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import dayjs from 'dayjs';

import { state } from 'app/pwa/app.cerebral';

import { PageWrapper, Title } from '../elements';

import PageContainer from '../common/PageContainer';
import { TermsWrapper, Updated, Tracking } from './elements';
import { useConfig, useText } from 'common/hooks';

const matomoLanguages = {
  en: 'en',
  ja: 'ja',
  no: 'nb',
};

const deps = {
  termsUpdatedDatetime: state.appContainer.termsUpdatedDatetime,
};

function Privacy({
  termsUpdatedDatetime,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const { matomoTrackingUrl } = useConfig();

  return (
    <PageContainer tab={'terms'}>
      <PageWrapper>
        <Title as={'h2'}>
          {t('account.settings.privacy.privacy_and_terms')}
        </Title>
        <TermsWrapper>
          {t('privacy.terms')}
          <Updated>
            {t('appContainer.ModTerms.last_updated', {
              date: dayjs(termsUpdatedDatetime).format('LL'),
            })}
          </Updated>
        </TermsWrapper>
        <Tracking
          src={`${matomoTrackingUrl}/index.php?module=CoreAdminHome&action=optOut&language=${
            matomoLanguages[t.locale]
          }&backgroundColor=f9fcff&fontColor=263238&fontSize=14px&fontFamily=sans-serif`}
        />
      </PageWrapper>
    </PageContainer>
  );
}

export default connect(deps, Privacy);
